import React, { useRef, useEffect } from "react";

const ShippingInfoModal = ({ show, onClose }) => {
  const modalRef = useRef();

  useEffect(() => {
    if (!show) return;

    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show, onClose]);

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
      <div
        ref={modalRef}
        className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md relative max-h-96 overflow-y-auto z-[10000]"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="text-2xl font-bold mb-4 text-gray-900">
          Shipping Information
        </h2>

        <div className="space-y-4 text-gray-700">
          <div>
            <h3 className="font-semibold text-lg mb-2 text-gray-900">
              Product Shipping
            </h3>
            <p className="text-sm">
              Standard shipping for product orders typically takes 5-7 business
              days. Your order will be carefully packaged and shipped via USPS,
              FedEx, or UPS.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2 text-gray-900">
              Service Shipping
            </h3>
            <p className="text-sm">
              Service shipping is $10 per order, regardless of the number of
              services purchased. All service orders include a shipping label for
              a single pair of shoes. If you would like to send more pairs,
              please contact us to purchase additional shipping labels. 
              For info on estimated service turnaround times, please refer to the FAQ section.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2 text-gray-900">
              Tracking
            </h3>
            <p className="text-sm">
              Once your order ships, you'll receive a tracking number via email.
              You can use this to monitor your package in real-time.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2 text-gray-900">
              International Shipping
            </h3>
            <p className="text-sm">
              We currently only ship within the United States and do not ship
              internationally.
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full mt-6 px-4 py-2 bg-indigo-600 text-white rounded-full font-semibold hover:bg-indigo-700 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ShippingInfoModal;